import './bootstrap';
import {gsap} from 'gsap';
import {ExpoScaleEase, RoughEase, SlowMo} from 'gsap/EasePack';
import {ScrollTrigger} from 'gsap/ScrollTrigger';
import {Observer} from 'gsap/Observer';
import {EaselPlugin} from 'gsap/EaselPlugin';
import Swiper from 'swiper/bundle';
import 'swiper/css/bundle';
import Cookies from 'js-cookie';

window.Swiper = Swiper;

import {Alpine, Livewire} from '../../../../vendor/livewire/livewire/dist/livewire.esm';
import collapse from '@alpinejs/collapse';

let map;

function initMap() {
    // The map, centered at Uluru
    map = new google.maps.Map(document.getElementById('map'), {
        zoom: 4,
    });

    window.dispatchEvent(new Event('map-loaded'));
}

import menu from './menu';
import ProductImagesCarousel from './product-images-carousel';
import featuredCollectionProducts from './featured-collection-products';
import categoriesCarousel from './categories-carousel';
import productsTabCarousel from './products-tab-carousel';
import dropdown from './dropdown';
import categoryTabs from './category-tabs';
import heroCarousel from './hero-carousel';
import PriceRangeSlider from './price-range-slider';
import ProductsCarousel from './products-carousel';
import infoCarousel from './info-carousel';
import bannersCarousel from './banners-carousel';
import ourValuesCarousel from './our-values-carousel';
import blogCarousel from './posts-carousel';
import {animateFrom, hide} from './utils';

Alpine.data('menu', menu);
Alpine.data('dropdown', dropdown);
Alpine.data('categoryTabs', categoryTabs);
Alpine.data('priceRangeSlider', PriceRangeSlider);
Alpine.data('productImagesCarousel', ProductImagesCarousel);
Alpine.data('featuredCollectionProducts', featuredCollectionProducts);
Alpine.data('categoriesCarousel', categoriesCarousel);
Alpine.data('productsTabCarousel', productsTabCarousel);
Alpine.data('productsCarousel', ProductsCarousel);
Alpine.data('heroCarousel', heroCarousel);
Alpine.data('infoCarousel', infoCarousel);
Alpine.data('bannersCarousel', bannersCarousel);
Alpine.data('ourValuesCarousel', ourValuesCarousel);
Alpine.data('blogCarousel', blogCarousel);

Alpine.store('sidebars', {
    showMenu: false,
    showQuickSearch: false,
    showQuickFilter: false,
    showOverlay: false,
    showCartDrawer: false,
    showAccountDrawer: false,
    showSizeGuide: false,
    toggleMenu() {
        this.showMenu = !this.showMenu;
        this.showQuickSearch = false;
        this.showOverlay = !this.showOverlay;
    },
    toggleQuickFilter() {
        this.showQuickFilter = !this.showQuickFilter;
        this.showOverlay = !this.showOverlay;
    },
    toggleQuickSearch() {
        this.showQuickSearch = !this.showQuickSearch;
    },
    toggleCartDrawer() {
        this.showCartDrawer = !this.showCartDrawer;
        this.showOverlay = !this.showOverlay;
    },
    toggleAccountDrawer() {
        this.showAccountDrawer = !this.showAccountDrawer;
        this.showOverlay = !this.showOverlay;
    },
    toggleSizeGuide() {
        this.showSizeGuide = !this.showSizeGuide;
        this.showOverlay = !this.showOverlay;
    },
    closeAll() {
        this.showMenu = false;
        this.showQuickSearch = false;
        this.showQuickFilter = false;
        this.showCartDrawer = false;
        this.showAccountDrawer = false;
        this.showSizeGuide = false;
        this.showOverlay = false;
    },
});

window.Alpine = Alpine;

Alpine.plugin(collapse);

gsap.config({
    nullTargetWarn: false,
    trialWarn: false,
});

gsap.registerPlugin(ScrollTrigger, Observer, EaselPlugin, ExpoScaleEase);

const revealElements = () => {
    let elements = document.querySelectorAll('.gs_reveal');
    elements.forEach((elem, index) => {
        hide(elem);

        ScrollTrigger.create({
            trigger: elem,
            onEnter: function () {
                animateFrom(elem, 1, index);
            },
            onEnterBack: function () {
                animateFrom(elem, -1, 0);
            },
            onLeave: function () {
                hide(elem);
            },
        });
    });
};

revealElements();

gsap.utils.toArray('.parallax-container').forEach(function (container) {
    let image = container.querySelector('img');

    gsap.to(image, {
        y: () => image.offsetHeight - container.offsetHeight,
        ease: 'none',
        scrollTrigger: {
            trigger: container,
            scrub: true,
            pin: false,
            markers: false,
            invalidateOnRefresh: true,
        },
    });
});

window.addEventListener('pushToDataLayer', function (event) {
    if (dataLayer) {
        dataLayer.push({ecommerce: null});
        dataLayer.push({user_data: null});
        dataLayer.push(JSON.parse(event.detail));
    }
});

// Add marketer API event listener
window.addEventListener('pushToMarketer', function (event) {
    if (dataLayer) {
        dataLayer.push({ecommerce: null});
        dataLayer.push({user_data: null});
        dataLayer.push(JSON.parse(event.detail));
    }

});


const pushDataToGTM = data => {
    dataLayer.push({search_term: null});
    dataLayer.push(JSON.parse(data));
};

window.addEventListener('pushSearchToDataLayer', function (event) {
    setTimeout(() => {
        pushDataToGTM(event.detail);
    }, 3000);
});


window.addEventListener('pushSearchToMarketer', function (event) {
    setTimeout(() => {
        pushDataToGTM(event.detail);
    }, 3000);
});

Livewire.start();
